import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'cv-footer-empty-rendered',
  template: `
      
  `,
  styleUrls: ['./footer-empty-rendered.component.scss']
})
export class FooterEmptyRenderedComponent implements ICellRendererAngularComp {

  constructor() { }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
  agInit(params: ICellRendererParams): void {

  }

}
